// extracted by mini-css-extract-plugin
export default {"storyDetailHeaderDescription":"c-r_hk","storyDetailHeaderDescription__time":"c-r_hl"};